import { motion } from "framer-motion";

export const scrollTo = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
    <div className="flex items-center gap-3">
        <span className="h-[2px] w-8 bg-orange" />
        <span
            className={`text-[11px] font-semibold uppercase tracking-wide2 ${
                light ? "text-white/70" : "text-navy/70"
            }`}
        >
            {children}
        </span>
    </div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
    <motion.span
        className={`block overflow-hidden ${className}`}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.1 }}
    >
        <motion.span
            className="block will-change-transform"
            variants={{
                hidden: { y: "110%" },
                show: { y: 0, transition: { duration: 1, delay, ease: [0.16, 1, 0.3, 1] } },
            }}
        >
            {children}
        </motion.span>
    </motion.span>
);
